import type { FaireBrandEntity } from "../../entity_types/brand";

export const faire_source_multi_brand: FaireBrandEntity = {
  token: "faire-source-multi-brand",
  type: "brand",
  name: "Faire Source",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/fd3d710ef1b00e98253d2e76765c2cb111c43daac1870e05e581857ef0c3ccd1.webp",
  minimumOrderDollars: 100,
  rating: 4.8,
  location: "United States",
  tags: ["cross-sell", "atc"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
